export const TermsSection1 = () => {
  return (
    <>
      <section id="acceptance">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            Welcome to WinGrow (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;). By accessing or
            using our lead management platform and services (the &quot;Service&quot;), you agree to
            be bound by these Terms of Service (&quot;Terms&quot;).
          </p>
          <p>
            If you do not agree to these Terms, please do not use our Service. We reserve the right
            to modify these Terms at any time, and your continued use of the Service constitutes
            acceptance of any changes.
          </p>
          <p>
            By using our Service, you represent that you are at least 18 years old and have the
            legal capacity to enter into this agreement.
          </p>
        </div>
      </section>

      <section id="service-description">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            WinGrow provides a lead management platform that integrates with Facebook, Instagram,
            WhatsApp, and Messenger to help businesses manage customer conversations, leads, and
            engagement. Our Service includes:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              Integration with Facebook Pages, Instagram Business Accounts, and WhatsApp Business
              Accounts
            </li>
            <li>
              Management of messages and conversations from Facebook Messenger, Instagram Direct
              Messages, and WhatsApp
            </li>
            <li>Lead tracking and contact management</li>
            <li>Analytics and insights from connected platforms</li>
            <li>AI-powered response suggestions and automation</li>
            <li>Post scheduling and content management</li>
          </ul>
          <p>
            The Service is provided on a subscription basis and may be modified, updated, or
            discontinued at our discretion with reasonable notice to users.
          </p>
        </div>
      </section>

      <section id="accounts">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          3. User Accounts and Registration
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>To use our Service, you must:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Create an account with accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Connect your Facebook, Instagram, or WhatsApp Business accounts</li>
            <li>Notify us immediately of any unauthorized access or security breach</li>
          </ul>
          <p>
            You are responsible for all activities that occur under your account. You agree to
            provide accurate, current, and complete information during registration and to update
            such information to keep it accurate, current, and complete.
          </p>
          <p>
            We reserve the right to suspend or terminate accounts that provide false information or
            violate these Terms.
          </p>
        </div>
      </section>
    </>
  );
};
